import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';
import Button, { ILink } from '../Button';
import Video, { IVideoProps } from '../VHSMediaModal';
export interface IVHSVideoProps extends IBaseElementProps {
	/**
	 * Style
	 */
	style: 'default' | 'wide';
	/**
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Video
	 */
	video?: IVideoProps;
	/**
	 *  Style
	 */
	videoStyle: 'modal' | 'inline';
	/**
	 * Content
	 * @control richtext
	 */
	content?: string;
	/**
	 * CTA
	 */
	cta?: ILink;
	/**
	 * Set Height Content
	 */
	setHeight?: boolean;
}

/**
 * Video
 * @block
 * @icon video-alt
 */
const VHSVideo: React.FC<IVHSVideoProps> = ({
	style,
	heading,
	video,
	videoStyle = 'inline',
	content,
	setHeight,
	cta,
}) => {
	const [showAll, setShowAll] = React.useState(false);

	return (
		<div className={
			cn('vhs-video',
				style === 'wide' && 'vhs-video--wide',
				setHeight  && 'vhs-video--set-height'
			)}>
			<div className="vhs-video__container">
				<div className="vhs-video__wrapper">
					{heading && (
						<h2 className="vhs-video__heading">{heading}</h2>
					)}
					{video && <Video className="vhs-video__video" {...video} style={videoStyle} />}
					{content && (
						<div
							className={cn(
								'vhs-video__content-wrapper',
								setHeight &&
									'vhs-video__content-wrapper--set-height',
							)}
						>
							{heading && (
								<h2 className="vhs-video__heading vhs-video__heading--content">
									{heading}
								</h2>
							)}
							<div className="vhs-video__content">
								<p
									dangerouslySetInnerHTML={{
										__html: content,
									}}
								/>
							</div>
							{cta?.label && (
								<Button
									{...cta}
									className={`vhs-video__cta btn btn-sm btn-tertiary ${
										setHeight ? '' : 'show-all-disabled'
									}`}
								/>
							)}
							{setHeight && (
								<Button
									className={cn(
										'vhs-video__show',
										setHeight ? 'set-height' : '',
										'text-overlay',
									)}
									onClick={(e) => {
										e.target?.parentNode.classList.toggle(
											'vhs-video__content-wrapper--set-height',
										);
										e.target?.classList.toggle(
											'text-overlay',
										);
										setShowAll(!showAll);
									}}
								>
									{showAll ? 'Show Less' : 'Show All'}
								</Button>
							)}
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default VHSVideo;
